<script>
import {
  BaseStoryCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import DynamicComponentActionElement
  from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";
import {
  ENGAGEMENT_ICONS,
  EngagementActionMixin,
} from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";
import ButtonActionOptions from "%/dynamic-component-editor/bundles/button-action-options";
import {
  SHARE_CONFIRMATION_MS,
  shareStory,
} from "%/dynamic-component-editor/standard-components/base-story-card/story-engagement-actions";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

export default {
  name: "ShareButton",
  actionLabel: "Share",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.ACTIONS,
    displayName: "Share Button",
    displayIcon: "hugeicons:share-01",
    elementGroup: "storyElements",
  },
  extends: DynamicComponentActionElement,
  mixins: [BaseStoryCardElementMixin, EngagementActionMixin],
  optionBundles: [
    new ButtonActionOptions({ "default.icon": ENGAGEMENT_ICONS.share }),
  ],
  data() {
    return {
      isShareConfirmed: false,
    };
  },
  computed: {
    isEngagementActive() {
      return this.isShareConfirmed;
    },
    engagementActiveIcon() {
      return ENGAGEMENT_ICONS.shared;
    },
    myValue() {
      return this.myDisplayValue === "show" ? this.entity?.numShares ?? 0 : "";
    },
    shouldShowAction() {
      return true;
    },
    shareUrl() {
      return `${this.links.web}/story/${this.storyEntityId}`;
    },
  },
  methods: {
    handleClick() {
      if (this.editMode || this.isPreviewMode) {
        return;
      }
      const storyId = this.storyEntityId;
      shareStory(storyId, { title: this.entity.title, url: this.shareUrl }, () => {
        this.isShareConfirmed = true;
        setTimeout(() => {
          this.isShareConfirmed = false;
        }, SHARE_CONFIRMATION_MS);
      });
    },
  },
};
</script>
